import React from "react";
import HeroCarouselV2 from "./v2/HeroCarouselV2";
import { HomeBanner } from "@/packages/types/banner";

interface BannerProps {
  banners: HomeBanner[];
  className?: string;
  showIfSingle?: number;
}

const Banner: React.FC<BannerProps> = ({
  banners,
  className = "",
  showIfSingle = 1,
}) => {
  const defaultHeight = "h-[150px] md:h-[445px]";
  const hasCustomHeight = /h-\[.*?\]/.test(className);
  const heightClass = hasCustomHeight ? "" : defaultHeight;

  if (!banners || banners.length === 0 || showIfSingle === 0) return null;

  return (
    <HeroCarouselV2
      banners={banners}
      className={`${heightClass} ${className}`}
    />
  );
};

export default Banner;
